<template>
  <div>
    <div class="md-layout-item">
      <md-card>
        <md-card-header class="md-card-header-text md-card-header-green">
          <div class="card-text">
            <h4 class="title">الصلاحيات</h4>
          </div>
        </md-card-header>
        <md-card-content class="mt-25">
          <div v-if="loading" class="loading-container">
            <md-progress-bar md-mode="indeterminate"></md-progress-bar>
            <p>جاري تحميل الصلاحيات...</p>
          </div>

          <div v-else class="permissions-container">
            <!-- تحديد كل الصلاحيات -->
            <div class="permission-section">
              <md-checkbox
                v-model="isAllSelected"
                @change="toggleAllPermissions"
                class="main-checkbox"
              >
                تحديد كل الصلاحيات
              </md-checkbox>
            </div>

            <!-- الأقسام -->
            <div
              v-for="section in sections"
              :key="section.type"
              class="permission-section"
            >
              <div class="section-header">
                <h3 class="section-title">{{ section.name }}</h3>
              </div>
              <div class="section-select-all">
                <md-checkbox
                  v-model="sectionSelectionState[section.type]"
                  @change="toggleAllInSection(section.type)"
                  class="section-checkbox"
                >
                  تحديد الكل
                </md-checkbox>
              </div>

              <div class="permissions-grid">
                <md-checkbox
                  v-for="item in section.items"
                  :key="item.value"
                  v-model="selectedPermissions"
                  :value="item.value"
                >
                  {{ item.label }}
                </md-checkbox>
              </div>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "HrPermissionsSelector",

  computed: {
    selectedPermissions: {
      get() {
        return this.$store.getters["permissions/getSelectedPermissions"];
      },
      set(value) {
        this.$store.dispatch("permissions/updateSelectedPermissions", value);
      },
    },
    sections() {
      return this.$store.getters["permissions/getPermissionsSections"];
    },
    loading() {
      return this.$store.getters["permissions/getPermissionsLoading"];
    },
    isAllSelected: {
      get() {
        return this.$store.getters["permissions/isAllPermissionsSelected"];
      },
      set(value) {
        // The actual logic is handled by toggleAllPermissions method
        // This setter is required for v-model but the change event handles the logic
      }
    },
    sectionSelectionState() {
      return this.$store.getters["permissions/getSectionSelectionState"];
    },
  },

  methods: {
    isSectionSelected(sectionType) {
      return this.sectionSelectionState[sectionType] || false;
    },

    isPermissionSelected(permissionValue) {
      return this.selectedPermissions.includes(permissionValue);
    },

    togglePermission(permission) {
      this.$store.dispatch("permissions/togglePermission", permission);
    },

    toggleAllPermissions() {
      this.$store.dispatch("permissions/toggleAllPermissions");
    },

    toggleAllInSection(sectionType) {
      this.$store.dispatch("permissions/toggleAllInSection", sectionType);
    },
  },
};
</script>

<style lang="scss" scoped>
.loading-container {
  text-align: center;
  padding: 40px 20px;

  p {
    margin-top: 15px;
    color: #666;
    font-size: 14px;
  }
}

.permissions-container {
  padding: 20px 0;

  .permission-section {
    margin-bottom: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 20px;
    background-color: #fafafa;

    &:hover {
      background-color: #f5f5f5;
      transition: background-color 0.3s ease;
    }

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ddd;

      .section-title {
        margin: 0;
        color: #333;
        font-weight: 600;
      }

      .section-checkbox {
        color: #4caf50;
      }
    }

    .section-select-all {
      margin-bottom: 5px;
      padding-left: 10px;

      .section-checkbox {
        color: #4caf50;
        font-weight: 500;
      }
    }

    .permissions-grid {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      gap: 15px;
      margin-top: 5px;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(4, 1fr);
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 480px) {
        grid-template-columns: 1fr;
      }
    }
  }

  .main-checkbox {
    font-weight: bold;
    color: #2196f3;
    font-size: 16px;
  }
}
</style>
